import * as React from 'react';
import {PixelRatio, Platform, TouchableOpacity, View} from 'react-native';
import {useSelector} from 'react-redux';
import {useAppDispatch, useAppSelector} from '../../../redux';
import {clearFields, getFormValues, initialize} from 'redux-form';

import {useStyles} from '../../../shared/hooks/styles';
import {LoginState} from '../../../shared/models/login/loginStep';
import {Forms} from '../../../shared/models/forms';
import {RegistrationOrRecoveryForm} from '../../../shared/models/login';
import {resetLoginState} from '../../../redux/actions/login';
import {LoginStepSelector} from '../../../redux/selectors/runtime/loginStep';
import {setRuntimeLoginStepState} from '../../../redux/actions/runtime/loginStep';
import {Text} from '../../../shared/components/text';
import {profileSessionExpiredSelector} from '../../../redux/selectors/profile';
import {AppActions} from '../../../redux/actions';
import {profileSlice} from '../../../redux/reducers/profile';
import {DeviceSize} from '../../../shared/theme/helpers';

export const Back: React.FC<{onBack?: () => void}> = ({onBack}) => {
  const isSessionExpired = useSelector(profileSessionExpiredSelector());
  const registrationFormInfo = useAppSelector((state) =>
    getFormValues(Forms.registrationOrRecoveryForm)(state),
  ) as RegistrationOrRecoveryForm;

  const dispatch = useAppDispatch();
  const step = useSelector(LoginStepSelector());

  const density = PixelRatio.get();
  const isSmallScreen = density <= 2 && Platform.OS !== 'web';
  const styles = useStyles(({theme, mediaOnly}) => {
    return {
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: isSmallScreen ? 8 : 16,
      },
      buttonHolder: {
        height: 44,
      },
      text: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.h6Light),
        color: theme.color.primaryNonGreyBackground,
      },
      buttonContentContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.color.primaryColor,
      },
    };
  });

  const onPressBack = () => {
    switch (step) {
      case LoginState.enter:
        dispatch(resetLoginState());
        dispatch(clearFields(Forms.enterForm, false, false, 'card'));
        break;
      case LoginState.forgotPassword:
      case LoginState.forgotPasswordNotCard:
      case LoginState.forgotPasswordCode:
      case LoginState.forgotPasswordEmail:
        dispatch(resetLoginState());
        dispatch(setRuntimeLoginStepState(LoginState.enter));
        break;
      case LoginState.forgotPasswordPasswords:
        dispatch(initialize(Forms.loginForm, {identificator: registrationFormInfo.identificator}));
        dispatch(setRuntimeLoginStepState(LoginState.login));
        break;
      case LoginState.login:
      case LoginState.agreement:
      case LoginState.registrationPasswords:
      case LoginState.registrationCode:
      case LoginState.phoneNumberCheck:
        if (step === LoginState.login && isSessionExpired) {
          dispatch({type: AppActions.Reset});
          dispatch(profileSlice.actions.reset(null));
        }
        dispatch(resetLoginState());
        dispatch(setRuntimeLoginStepState(LoginState.enter));
        break;
      case LoginState.esiaLogin:
        dispatch(resetLoginState());
        dispatch(setRuntimeLoginStepState(LoginState.enter));
        break;
      case LoginState.esiaRegCardUsersHandling:
        dispatch(setRuntimeLoginStepState(LoginState.esiaRegCardUnconfirmed));
        break;
      case LoginState.esiaRegCardDeliveryHandling:
        dispatch(setRuntimeLoginStepState(LoginState.esiaRegCardUsersHandling));
        break;
      case LoginState.esiaRegCardUnconfirmed:
        dispatch({type: AppActions.Reset});
        dispatch(profileSlice.actions.reset(null));
        break;
      default:
        break;
    }

    onBack?.();
  };

  return (
    <View style={styles.buttonHolder}>
      <TouchableOpacity testID='login-go-back-id' style={styles.container} onPress={() => onPressBack()}>
        <Text style={styles.text}>Вернуться назад</Text>
      </TouchableOpacity>
    </View>
  );
};
